import React from "react"

import ListWidgetHeader from "../../common/ListWidgetHeader"
import SearchBar from "../../common/SearchBar"
import StakeholderListContainer from "./StakeholderListContainer"

type Props = {
    onFilterSelect: Object => void,
    canAdd: boolean,
    isFetching: boolean,
    invalidate: Object => void,
    pagingRequest: Object,
    nameSearchTerm: string,
    isEmptySearchValue: boolean,
    onSearch: void => void,
    onAdd: void => void
}

const StakeholderListWidget = ({
    onFilterSelect,
    canAdd,
    isFetching,
    invalidate,
    pagingRequest,
    nameSearchTerm,
    isEmptySearchValue,
    onSearch,
    onAdd
}: Props) => (
    <div className="widget">
        <ListWidgetHeader
            isFetching={isFetching}
            canAdd={canAdd}
            iconComponent={<span className="icon icon-stakeholders" />}
            listTitle="Stakeholders"
            invalidate={invalidate(pagingRequest)}
            onAdd={onAdd}
            onFilterSelect={onFilterSelect(pagingRequest)}
        />
        <div className="quick-filters">
            <SearchBar
                name={"full_name"}
                searchTerm={nameSearchTerm}
                onSearch={onSearch}
            />
        </div>
        <StakeholderListContainer />
    </div>
)

export default StakeholderListWidget
